import React, { useEffect, useState } from 'react';
import { useParams, Link } from 'react-router-dom';

const C = {
  maroon: '#5B1818', maroonDark: '#3B0E0E', gold: '#C9A23A', goldLight: '#E2C170', goldSoft: '#F0DCA0',
  cream: '#FBF6E9', creamWarm: '#FFF8EB', creamDeep: '#F4EAD2',
  text: '#2A1410', textMuted: '#5A3A28',
  border: 'rgba(201, 162, 58, 0.35)', borderStrong: 'rgba(201, 162, 58, 0.55)',
  success: '#2D7A4F',
};

const SubmittedPage = () => {
  const { leadId } = useParams();
  const [lead, setLead] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchLead = async () => {
      try {
        const res = await fetch(`/api/report/${leadId}`);
        const data = await res.json();
        if (!data.error) setLead(data);
      } catch (err) { console.error(err); }
      setLoading(false);
    };
    fetchLead();
  }, [leadId]);

  const pageStyle = { background: C.cream, fontFamily: "'Noto Sans Devanagari', sans-serif", color: C.text, minHeight: '100vh' };

  if (loading) return <div style={pageStyle} className="flex items-center justify-center"><div style={{ color: C.maroon }} className="text-xl">Loading...</div></div>;

  if (!lead) {
    return (
      <div style={pageStyle} className="flex items-center justify-center" data-testid="submitted-page-error">
        <div className="text-center">
          <p style={{ color: C.maroon }} className="text-xl mb-4">रिकॉर्ड नहीं मिला।</p>
          <Link to="/" className="px-6 py-3 rounded-full font-bold inline-block" style={{ background: `linear-gradient(135deg, ${C.gold}, ${C.goldLight})`, color: '#2A1208' }}>होम पर जाएं</Link>
        </div>
      </div>
    );
  }

  return (
    <div style={pageStyle} data-testid="submitted-page">
      {/* Header */}
      <header className="py-10 px-4" style={{ background: `linear-gradient(135deg, ${C.maroonDark} 0%, ${C.maroon} 50%, ${C.maroonDark} 100%)`, borderBottom: `2px solid ${C.gold}` }}>
        <div className="max-w-4xl mx-auto text-center">
          <div className="text-5xl mb-3" style={{ color: C.success }}>✓</div>
          <h1 className="text-3xl sm:text-4xl font-bold" style={{ color: C.goldSoft, fontFamily: "'Tiro Devanagari Hindi', 'Rozha One', serif" }}>आपकी अर्जी सफलतापूर्वक जमा हुई</h1>
          <p className="mt-2 text-sm tracking-widest uppercase" style={{ color: C.goldLight }}>माता मलिहा जी के दरबार में आपकी अर्जी लग चुकी है</p>
        </div>
      </header>

      <main className="max-w-2xl mx-auto px-4 py-10">
        <div className="text-center mb-8">
          <h2 className="text-2xl font-bold mb-2" style={{ color: C.maroon, fontFamily: "'Tiro Devanagari Hindi', serif" }}>{lead.name} जी, धन्यवाद</h2>
          <p style={{ color: C.textMuted }}>आपकी पूरी जानकारी हमारे पास सुरक्षित है</p>
          <div className="mx-auto mt-4 h-px" style={{ width: 90, background: `linear-gradient(90deg, transparent, ${C.gold}, transparent)` }} />
        </div>

        {/* Email reminder */}
        <section className="rounded-2xl p-7 mb-6 text-center" style={{ background: `linear-gradient(135deg, ${C.gold} 0%, ${C.goldLight} 100%)`, border: `2px solid ${C.maroon}`, boxShadow: '0 6px 24px rgba(201,162,58,0.30)' }} data-testid="email-reminder">
          <div className="text-4xl mb-3" style={{ color: C.maroonDark }}>✉</div>
          <h3 className="text-2xl font-bold mb-3" style={{ color: C.maroonDark, fontFamily: "'Tiro Devanagari Hindi', serif" }}>अभी अपना Email Check करें</h3>
          <p className="text-base mb-2" style={{ color: C.maroon }}>
            हमने आपको <strong style={{ color: C.maroonDark }}>{lead.email}</strong> पर<br />
            <strong>Confirmation Email</strong> भेजा है
          </p>
          <p className="text-sm" style={{ color: C.maroon }}>2 घंटे में आपकी समस्या की <strong>विस्तृत रिपोर्ट</strong> भी इसी Email पर आएगी।</p>
          <p className="text-xs mt-3" style={{ color: C.maroon, opacity: 0.85 }}>! अगर Inbox में Email न दिखे तो Spam / Promotions folder ज़रूर check करें।</p>
        </section>

        {/* User Details */}
        <section className="rounded-2xl p-6 mb-6" style={{ background: C.creamWarm, border: `1px solid ${C.border}`, boxShadow: '0 4px 20px rgba(91,24,24,0.08)' }} data-testid="user-details">
          <h3 className="text-xl font-bold mb-4" style={{ color: C.maroon, fontFamily: "'Tiro Devanagari Hindi', serif" }}>आपकी जमा की गई जानकारी</h3>
          <div className="space-y-3">
            {[['नाम', lead.name, 'detail-name'], ['Email', lead.email, 'detail-email'], ['Mobile', lead.mobile1, 'detail-mobile']].map(([l, v, t]) => (
              <div key={t} className="flex flex-col sm:flex-row sm:justify-between gap-1 pb-3" style={{ borderBottom: `1px dashed ${C.border}` }}>
                <span className="font-bold" style={{ color: C.maroon }}>{l}:</span>
                <span style={{ color: C.text }} data-testid={t}>{v}</span>
              </div>
            ))}
            <div className="flex flex-col gap-1">
              <span className="font-bold" style={{ color: C.maroon }}>आपकी समस्या:</span>
              <span style={{ color: C.text }} className="text-sm leading-relaxed" data-testid="detail-problem">{lead.problem}</span>
            </div>
          </div>
        </section>

        {/* Contact */}
        <section className="rounded-2xl p-7 mb-6 text-center" style={{ background: C.creamWarm, border: `2px solid ${C.success}`, boxShadow: '0 4px 20px rgba(45,122,79,0.10)' }}>
          <h3 className="text-xl font-bold mb-3" style={{ color: C.maroon, fontFamily: "'Tiro Devanagari Hindi', serif" }}>किसी भी जानकारी के लिए सेविका से बात करें</h3>
          <p className="mb-5 text-sm leading-relaxed" style={{ color: C.textMuted }}>माता जी के सेवा दल की सेविका से सीधे call पर अपनी समस्या पर बात करें।</p>
          <a href="tel:9241165807" data-testid="call-cta-button" className="inline-flex items-center justify-center gap-3 px-9 py-4 rounded-full text-lg font-bold transition-all transform hover:scale-105" style={{ background: C.success, color: '#fff', boxShadow: '0 6px 24px rgba(45,122,79,0.35)' }}>
            <span>📞</span>
            <span>सेविका को Call करें</span>
          </a>
        </section>

        {/* Next Steps */}
        <section className="rounded-2xl p-6 mb-6" style={{ background: C.creamWarm, border: `1px solid ${C.border}` }}>
          <h3 className="text-lg font-bold mb-3" style={{ color: C.maroon, fontFamily: "'Tiro Devanagari Hindi', serif" }}>आगे क्या होगा?</h3>
          <ul className="space-y-2 text-sm" style={{ color: C.text }}>
            <li className="flex items-start gap-3"><span style={{ color: C.gold }}>1.</span><span>अभी आपके email पर <strong>Confirmation</strong> पहुँच गया है</span></li>
            <li className="flex items-start gap-3"><span style={{ color: C.gold }}>2.</span><span>2 घंटे में <strong>विस्तृत Report</strong> Email पर आएगी</span></li>
            <li className="flex items-start gap-3"><span style={{ color: C.gold }}>3.</span><span>किसी भी जानकारी के लिए सेविका से call पर बात करें</span></li>
            <li className="flex items-start gap-3"><span style={{ color: C.gold }}>4.</span><span>संतुष्ट हों तो <strong>क्षमतानुसार दक्षिणा</strong> देकर साधना शुरू करें</span></li>
          </ul>
        </section>

        <div className="rounded-xl p-4 mt-8 text-center" style={{ background: 'rgba(91,24,24,0.04)', border: `1px solid ${C.border}` }}>
          <p className="text-sm" style={{ color: C.textMuted }}>❖ अघोर विधि से कार्य होता है | पूरी श्रद्धा-विश्वास हो तभी आएं ❖</p>
        </div>
      </main>

      <footer className="py-8 text-center" style={{ background: `linear-gradient(180deg, ${C.maroon} 0%, ${C.maroonDark} 100%)`, borderTop: `2px solid ${C.gold}` }}>
        <div className="text-2xl mb-2" style={{ color: C.gold }}>ॐ</div>
        <p className="font-bold tracking-widest" style={{ color: C.goldSoft }}>जय माता मलिहा</p>
      </footer>
    </div>
  );
};

export default SubmittedPage;
